"use client";

import { useParams } from "next/navigation";
import { useMemo } from "react";
import useCookie from "./useCookie";

/**
 * This hook gets the country param or location from cookie.
 * Returns the country code.
 */
export function useCountryCode(): {
  country: string;
  paramsHasCountry: boolean;
} {
  const { country } = useParams<{ country?: string }>();
  const location = useCookie();

  const countryCode = useMemo(() => {
    if (country) {
      return country;
    } else if (location) {
      return location;
    }
    return "us";
  }, [country, location]);

  const paramsHasCountry = typeof country === "string" && country.length === 2;

  return { country: countryCode, paramsHasCountry };
}
